// Challenge target type translations
export const TARGET_TYPE_TRANSLATIONS: Record<string, string> = {
  'goals_completed': 'obiective completate',
  'goals_created': 'obiective create',
  'progress_updates': 'actualizări progres',
  'weight_loss': 'kg slăbite',
  'fitness_improvement': '% îmbunătățire fitness',
  'active_days': 'zile active',
  'nutrition_days': 'zile nutriție',
  'muscle_gain': 'kg masă musculară',
  'medication_logs': 'zile tratament',
  'symptom_reduction': '% reducere simptome',
  'mobility_improvement': '% îmbunătățire mobilitate',
  'pain_reduction': '% reducere durere',
  'symptom_logs': 'zile monitorizare',
};

export function translateTargetType(targetType: string): string {
  return TARGET_TYPE_TRANSLATIONS[targetType] || targetType.replace(/_/g, ' ');
}

// Helper text explaining how challenges work
export const CHALLENGES_HELP_TEXT = `
**Cum Funcționează Provocările:**

1. **Înscrie-te** la o provocare din tab-ul "Disponibile"
2. **Lucrează la obiectivele tale** din pagina Obiective
3. **Progresul se actualizează automat** când:
   - Completezi obiective
   - Actualizezi progresul
   - Creezi obiective noi
4. **Câștigi puncte și insigne** când completezi provocarea!

**Tipuri de Provocări:**
- **Ușor**: Perfecte pentru începători (50-100 puncte)
- **Mediu**: Necesită efort constant (150-250 puncte)  
- **Dificil**: Pentru cei dedicați (300-1000 puncte)

**Sfat**: Începe cu provocări ușoare și avansează treptat!
`;
